import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const FileList = () => {
  // Statik klasör verileri (Gelecekte dinamikleşebilir)
  const myfiles = [
    { id: 1, name: "Blog Görselleri", file: 12, size: "1.2 GB", icon: "bx bxs-image" },
    { id: 2, name: "Sürücü Evrakları", file: 86, size: "4.5 GB", icon: "bx bxs-file-pdf" },
    { id: 3, name: "Sistem Faturaları", file: 34, size: "0.8 GB", icon: "bx bxs-receipt" }
  ];

  return (
    <React.Fragment>
      <div>
        <Row className="mb-3">
          <Col xl={12}>
            <div className="mt-2"><h5>Ana Dizinler</h5></div>
          </Col>
        </Row>
      </div>
      <div>
        <Row>
          {myfiles.map((file) => (
            <Col xl={4} sm={6} key={file.id}>
              <Card className="shadow-none border cursor-pointer hover-shadow transition-all">
                <CardBody className="p-3">
                  <div className="avatar-sm me-3 mb-3">
                    <div className="avatar-title bg-primary-subtle rounded">
                      <i className={`${file.icon} font-size-24 text-primary`}></i>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="overflow-hidden">
                      <h5 className="font-size-14 text-truncate mb-1 text-dark">{file.name}</h5>
                      <p className="text-muted text-truncate mb-0">{file.file} Dosya</p>
                    </div>
                    <div><p className="text-muted mb-0">{file.size}</p></div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default FileList;